import $ from "jquery"
import Chart from "chart.js/auto"

globalThis.$ = $
globalThis.jQuery = $
globalThis.Chart = Chart

// アクティブなタブが見えるようにスクロールコンテナを自動スクロール
function scrollActiveTabIntoView() {
  document.querySelectorAll(".js-scroll-active-wrap").forEach(wrap => {
    const active = wrap.querySelector(".js-scroll-active")
    if (!active) return

    // アクティブ要素の左端をコンテナの中央に揃える
    const wrapLeft = wrap.getBoundingClientRect().left
    const activeLeft = active.getBoundingClientRect().left
    const offset = activeLeft - wrapLeft - (wrap.clientWidth / 2) + (active.clientWidth / 2)
    wrap.scrollLeft = wrap.scrollLeft + offset
  })
}

document.addEventListener("turbo:load", scrollActiveTabIntoView)
document.addEventListener("DOMContentLoaded", scrollActiveTabIntoView)

// ── ML 予想 非同期取得 ─────────────────────────────────────────────


function setPredStatus(text, modifier) {
  const el = document.getElementById("js-pred-status")
  if (!el) return
  el.textContent = text
  el.className = `pred-status pred-status--${modifier}`
}

function setLoadingDone(selector, content, className) {
  document.querySelectorAll(selector).forEach(cell => {
    if (cell.querySelector(".pred-loading-dot")) {
      cell.className = `val-td ${className || "muted-val"}`
      cell.innerHTML = content
    }
  })
}

function updateBoatBadge(id, boatNo) {
  const el = document.getElementById(id)
  if (!el || !boatNo) return
  el.className = `result-boat result-boat--sm boat-badge-${boatNo}`
  el.textContent = boatNo
}

function calcHits(pred1, pred2, pred3, actual) {
  const a1 = actual.first, a2 = actual.second, a3 = actual.third
  const sortedPred = [pred1, pred2, pred3].filter(Boolean).sort((a, b) => a - b).join("-")
  const sortedAct  = [a1, a2, a3].filter(Boolean).sort((a, b) => a - b).join("-")
  const sortedPred2 = [pred1, pred2].filter(Boolean).sort((a, b) => a - b).join("-")
  const sortedAct2  = [a1, a2].filter(Boolean).sort((a, b) => a - b).join("-")
  return {
    win:      pred1 === a1,
    exacta:   pred1 === a1 && pred2 === a2,
    quinella: sortedPred2 === sortedAct2,
    trifecta: pred1 === a1 && pred2 === a2 && pred3 === a3,
    trio:     sortedPred === sortedAct,
  }
}

function updateResultBlock(predictions) {
  const finish = document.getElementById("js-result-finish")
  if (!finish) return

  const actual  = JSON.parse(finish.dataset.actual  || "null")
  const payouts = JSON.parse(finish.dataset.payouts || "{}")
  if (!actual) return

  // pred_rank 昇順で1〜3着予想艇を決定
  const sorted = [...predictions].filter(p => p.pred_rank).sort((a, b) => a.pred_rank - b.pred_rank)
  const pred1 = sorted[0]?.boat_no ?? null
  const pred2 = sorted[1]?.boat_no ?? null
  const pred3 = sorted[2]?.boat_no ?? null

  updateBoatBadge("js-eval-pred-1", pred1)
  updateBoatBadge("js-eval-pred-2", pred2)
  updateBoatBadge("js-eval-pred-3", pred3)

  // 的中バッジを再計算
  const hits = calcHits(pred1, pred2, pred3, actual)
  document.querySelectorAll("[data-hit-type]").forEach(el => {
    const type    = el.dataset.hitType
    const label   = el.dataset.hitLabel
    const hit     = hits[type]
    const payout  = payouts[type]
    el.className  = `result-hit-item ${hit ? "is-hit" : "is-miss"}`
    el.innerHTML  = `<span class="result-hit-label">${label}</span>` +
      (hit
        ? `<span class="result-hit-mark">✓</span>${payout ? `<span class="result-hit-payout">¥${Number(payout).toLocaleString()}</span>` : ""}`
        : `<span class="result-hit-mark">✗</span>`)
  })
}

function applyMLPredictions(predictions, oddsWin) {
  predictions.forEach(pred => {
    const boat = pred.boat_no

    // 着順予想
    const rankCell = document.querySelector(`[data-pred-rank-boat="${boat}"]`)
    if (rankCell && rankCell.querySelector(".pred-loading-dot")) {
      const r = pred.pred_rank
      rankCell.className = `val-td pred-rank-td pred-rank-${r}`
      rankCell.innerHTML = r
        ? `<span class="pred-rank-badge pred-rank-badge-${r}">${r}位</span>`
        : `<span class="muted-val">－</span>`
    }

    // スコア（生値。負の値もあり得る）
    const scoreCell = document.querySelector(`[data-pred-score-boat="${boat}"]`)
    if (scoreCell && scoreCell.querySelector(".pred-loading-dot")) {
      scoreCell.className = "val-td muted-val"
      scoreCell.textContent = pred.score.toFixed(3)
    }
  })

  updateResultBlock(predictions)
  setPredStatus("ML予想", "ml")
}

function applyActualResults(evalData) {
  const rankMap = {}
  if (evalData.actual_1st) rankMap[evalData.actual_1st] = 1
  if (evalData.actual_2nd) rankMap[evalData.actual_2nd] = 2
  if (evalData.actual_3rd) rankMap[evalData.actual_3rd] = 3

  document.querySelectorAll("[data-pred-rank-boat]").forEach(cell => {
    if (!cell.querySelector(".pred-loading-dot")) return
    const boat = parseInt(cell.dataset.predRankBoat)
    const rank = rankMap[boat]
    if (rank) {
      cell.className = `val-td pred-rank-td pred-rank-${rank}`
      cell.innerHTML = `<span class="pred-rank-badge pred-rank-badge-${rank} pred-rank-actual">${rank}着</span>`
    } else {
      cell.className = "val-td muted-val"
      cell.innerHTML = `<span class="muted-val">圏外</span>`
    }
  })

  // 確度・スコア・EV は非表示
  ;["[data-pred-conf-boat]", "[data-pred-score-boat]", "[data-pred-ev-boat]"].forEach(sel => {
    document.querySelectorAll(sel).forEach(cell => {
      if (cell.querySelector(".pred-loading-dot")) {
        cell.className = "val-td muted-val"
        cell.innerHTML = `<span class="muted-val">－</span>`
      }
    })
  })

  setPredStatus("結果", "result")
}

function fillCellsDash() {
  ;["[data-pred-rank-boat]", "[data-pred-conf-boat]", "[data-pred-score-boat]", "[data-pred-ev-boat]"].forEach(sel => {
    document.querySelectorAll(sel).forEach(cell => {
      if (cell.querySelector(".pred-loading-dot")) {
        cell.className = "val-td muted-val"
        cell.innerHTML = `<span class="muted-val">－</span>`
      }
    })
  })
}

// ML APIが予想なし（404）のとき — エラーではなく「対象外」
function setPredNone() {
  fillCellsDash()
  setPredStatus("予想なし", "none")
}

// 接続エラー・500系など実際に取得失敗したとき
function clearPredictions() {
  fillCellsDash()
  setPredStatus("取得不可", "error")
}

async function loadPredictions() {
  const wrap = document.querySelector(".stats-wrap[data-race-date]")
  if (!wrap) return

  const { raceDate, placeId, raceNo } = wrap.dataset
  const evalData = JSON.parse(wrap.dataset.evaluation || "null")
  const oddsWin  = JSON.parse(wrap.dataset.oddsWin  || "{}")

  const url = `/api/predictions/${raceDate}/${placeId}/${raceNo}`

  try {
    const resp = await fetch(url)

    if (resp.status === 404) {
      // ML APIが予想を持っていない（過去レースで結果あり → 結果表示 / なし → 予想なし）
      if (evalData) {
        applyActualResults(evalData)
      } else {
        setPredNone()
      }
      return
    }

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}))
      console.error("[ML予想]", resp.status, body.detail || body.error || "unknown")
      clearPredictions()
      return
    }

    const data = await resp.json()
    applyMLPredictions(data.predictions || [], oddsWin)
  } catch (e) {
    console.error("[ML予想] fetch失敗:", e)
    clearPredictions()
  }
}

document.addEventListener("turbo:load", loadPredictions)
document.addEventListener("DOMContentLoaded", loadPredictions)
